import 'css-chunk:src/applications/ProductFulfillmentApp/CreatorProductSelection/components/SendCatalog/SendEmail.scss';export default {
  "EmailContainer": "_EmailContainer_pmmqj_1",
  "MessageComposer": "_MessageComposer_pmmqj_9",
  "EmailComposer": "_EmailComposer_pmmqj_16",
  "hide": "_hide_pmmqj_20"
};